const STORY_ENTITY_TYPE = "Story";

const bareEntityType = type => String(type ?? "").split(".").at(-1);

function storyIdOf(context) {
  const pk = context?.entityPkUrlVars ?? context?.pk;
  const id = Number(pk?.id);
  return Number.isFinite(id) && id > 0 ? id : 0;
}

// A story is published or it is not -- that is a property of the STORY, never of
// who is looking at it. StoryAccess answers OPEN for a publication's own
// collaborators, which is why a collaborator's own draft rendered on their own
// staging site. The server half omits drafts from feeds; this is the client
// half, and it covers every constant/uri/context-sourced Story context rather
// than only the embed's constant bindings.
//
// XXX: unknown publish state fails CLOSED. An unhydrated entity returns
// XXX: undefined, and treating that as published would render the draft until
// XXX: the entity store catches up -- a visible leak on every cold load.
// XXX: Matches storyIsPublished(null) === false in the per-embed gate.
function dropUnpublishedStoryContexts(contexts, { onRenderSurface = false, isPublishedFor = null } = {}) {
  const source = contexts ?? {};
  if (!onRenderSurface || typeof isPublishedFor !== "function") {
    return source;
  }

  const kept = {};
  Object.keys(source).forEach(name => {
    const context = source[name];
    if (bareEntityType(context?.entityType) !== STORY_ENTITY_TYPE) {
      kept[name] = context;
      return;
    }
    const id = storyIdOf(context);
    if (!id) {
      kept[name] = context;
      return;
    }
    if (isPublishedFor(id) === true) {
      kept[name] = context;
    }
  });
  return kept;
}

module.exports = { dropUnpublishedStoryContexts, storyIdOf };
module.exports.default = { dropUnpublishedStoryContexts, storyIdOf };
